import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const userString = localStorage.getItem('user');
  const user = userString ? JSON.parse(userString) : null;

  const handleLogout = () => {
    navigate('/logoff');
  };

  const getRoleBadgeClass = () => {
    if (!user) return '';
    return user.role === 'ADMIN' ? 'role-badge role-admin' : 'role-badge role-standard';
  };

  const getRoleLabel = () => {
    if (!user) return '';
    return user.role === 'ADMIN' ? 'Admin' : 'Standard';
  };

  return (
    <header className="header">
      <div className="header-content">
        <Link to="/home" className="header-logo">
          <h1>Connect Administration App</h1>
        </Link>

        {user && (
          <div className="header-user-section">
            <div className="user-info">
              <span className="user-name">{user.name || user.lan_id || 'User'}</span>
              <div className="user-meta">
                <span className={getRoleBadgeClass()}>{getRoleLabel()}</span>
                {user.email && <span className="user-email">{user.email}</span>}
              </div>
            </div>
            <button className="logout-button" onClick={handleLogout}>
              Sign Out
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;